import React from "react";
import PageLayout from "../../components/Clearith/PageLayout";
import AboutContent from "../../components/Clearith/AboutContent";

const AboutPage: React.FC = () => {
  return (
    <PageLayout title="À propos" breadcrumb="À propos">
      <AboutContent />
    </PageLayout>
  );
};

export default AboutPage;
